import axios from "../library/axiosConfig";

export default {
  sendScanPoint(data){
    return axios.post(`/`, data, {baseURL: axios.defaults.analytics});
  },
  sendAnalytics (data) {
    return axios.post(`/batch`, data, {baseURL: axios.defaults.analytics});
  },
  dataAdd (data) {
    return axios.post(`/data/add`, data, {baseURL: axios.defaults.analytics});
  }
}



// WEBPACK FOOTER //
// ./src/api/analytics.js